import { ModalInputPopUpValidationsModel } from './ModalInputPopUpValidationsModel';

export class ModalInputPopUpViewModel {
  public static createEmpty(): ModalInputPopUpViewModel {
    return new ModalInputPopUpViewModel();
  }
  constructor(
    public Heading: string = '',
    public ModalDescription: string = '',
    public InputValue: string = '',
    public InputType: number = 0,
    public Placeholder: string = '',
    public MinValue: number | null = null,
    public MaxValue: number | null = null,
    public ValidationErrors: ModalInputPopUpValidationsModel[] = [],
    public SecondaryButtonText: string = '',
    public PrimaryButtonText: string = '',
  ) { }
}

